import { render } from "./LastNewUser.vue?vue&type=template&id=19433d58&ts=true"
import script from "./LastNewUser.ts?vue&type=script&lang=ts&external"
export * from "./LastNewUser.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__